export default "dist/images/components-columns-width-control-3-2-uneven.e813c20.png";